export default function Card({ img, title, text }: { img: string, title: string, text: any }) {
    return (
        <div className="rounded-[20px] px-[28.7px] py-[20.67px] bg-[#FFFFFF]">
            <div className="flex items-center gap-4">
                <img alt="icon" src={img} className="w-[57px] h-[57px] md:w-[100px] md:h-[100px]" />
                <p className="text-[20px] leading-[39px] text-[#000000] md:text-[36px] md:leading-[68px] font-semibold">{title}</p>
            </div>
            {text}
        </div>
    )
}